import authorRepository from "../repositories/AuthorRepository";

class AuthorService {
    constructor() {}

    async create(author) {
        return authorRepository.create(author);
    }

    async paginatedSearch(page, searchTerm) {
        return authorRepository.paginatedSearch(page, searchTerm);
    }
}

export default new AuthorService();
